/* Bull Ring Fabrics — head scripts, part 3 of 4 (2026-10-31, Abid). Scripts that used to be printed inline into the <head> of every
   page by the snippets named below (rendered from snippets/brf-local-business-schema). Moved into cached files. Loaded without defer,
   in order, at the same point in the head, so they run exactly when they used to. Each block is marked with the snippet it came from. */

/* ===== from snippets/brf-load-calm.liquid ===== */
/* Bull Ring 2026-10-30 (Abid): moving through the product photos picks that photo's colour, ready for Add to bag.
   Only photos that belong to a colour (the variant's own photo) change the colour; other photos leave it alone.
   Only shopper moves count (arrows, swipe, thumbnails, keys), never the page load or the gallery following a colour pick.
   The colour is chosen through the theme's own (hidden) option radio, so the label, colour picker, price, stock,
   sticky bar and the variant Add to bag uses all update as if the colour had been tapped. Plus a one-off tip on the photo.
   On load the gallery also opens on the selected colour's own photo (not the all-colours photo), so photo and colour match;
   the all-colours photo is still slide 1, one swipe/arrow back. */
(function(){
  if (window.__brfPhotoPick) return; window.__brfPhotoPick = 1;
  var doc = document, byMedia = {}, byFile = {}, opt = 1, userAt = 0, ownAt = 0, lastMedia = '', lastIdx = -1, t = 0, n = 0;
  function file(u){ var m = /\/([^\/?#]+?)(?:_\d+x\d*)?\.(?:jpe?g|png|webp|gif)(?:[?#]|$)/i.exec(u || ''); return m ? m[1] : ''; }
  function radioFor(v){
    var val = v['option' + opt]; if (val == null) return null;
    var rs = doc.querySelectorAll('.product-form__option .product-form__single-selector[name="option' + opt + '"]');
    for (var i = 0; i < rs.length; i++) if ((rs[i].getAttribute('data-value') || rs[i].value) === val) return rs[i];
    return null;
  }
  function pick(v){
    if (!v || Date.now() - ownAt < 1200) return;
    var r = radioFor(v); if (!r) return;
    if (r.tagName === 'OPTION') { if (r.selected) return; r.selected = true; r = r.parentNode; }
    else { if (r.checked) return; r.checked = true; }
    ownAt = Date.now(); hideTip();
    r.dispatchEvent(new Event('change', {bubbles: true}));
  }
  function user(e){ if (!e.isTrusted) return; if (e.target && e.target.closest && e.target.closest('.product-gallery, .brf-mg, .brf-garrow')) userAt = Date.now(); }
  function fresh(){ return Date.now() - userAt < 2500 && Date.now() - ownAt > 1200; }
  /* computers / tablets: the theme carousel marks the shown slide with is-selected */
  function desk(){
    var s = doc.querySelector('.product-gallery__carousel-item.is-selected'), id = s && s.getAttribute('data-media-id');
    if (!id || id === lastMedia) return; lastMedia = id;
    if (fresh()) pick(byMedia[id]);
  }
  /* phones: our own swipe gallery (brf-mg), settled slide = the one most in view */
  function phone(track){
    var sl = track.querySelectorAll('.brf-mg__slide'), tr = track.getBoundingClientRect(), best = -1, bd = 1e9;
    for (var i = 0; i < sl.length; i++) { var r = sl[i].getBoundingClientRect(), d = Math.abs(r.left + r.width / 2 - (tr.left + tr.width / 2)); if (d < bd) { bd = d; best = i; } }
    if (best < 0 || best === lastIdx) return; lastIdx = best;
    if (!fresh()) return;
    var img = sl[best].querySelector('img'); pick(img && byFile[file(img.currentSrc || img.src)]);
  }
  /* the one-off tip */
  var tip = null;
  function hideTip(){ if (!tip) return; var x = tip; tip = null; x.classList.remove('is-in'); setTimeout(function(){ if (x.parentNode) x.parentNode.removeChild(x); }, 300); }
  function showTip(){
    var seen = {}; try { seen = JSON.parse(localStorage.getItem('brf-tips') || '{}') || {}; } catch (e) { return; }
    if (seen.photopick || window.__brfTipShown || doc.documentElement.classList.contains('brf-consent-open')) return;
    var g = [].filter.call(doc.querySelectorAll('.brf-mg, .product-gallery__carousel'), function(x){ return x.offsetWidth > 0; })[0]; if (!g) return;
    var r = g.getBoundingClientRect(); if (r.top < -r.height * 0.4 || r.bottom > innerHeight + r.height * 0.4) return;
    window.__brfTipShown = 1; seen.photopick = 1; seen.gallery = 1;
    try { localStorage.setItem('brf-tips', JSON.stringify(seen)); } catch (e) {}
    tip = doc.createElement('div'); tip.className = 'brf-pp-tip'; tip.setAttribute('role', 'status');
    tip.textContent = (matchMedia('(hover: none)').matches ? 'Psst… swipe through the photos' : 'Psst… use the arrows to flick through the photos') + ' and we’ll pick that colour for you. Spot one you love? Just hit Add to bag 🧵';
    (g.closest('.brf-mg, .product-gallery__carousel-wrapper') || g).appendChild(tip);
    requestAnimationFrame(function(){ if (tip) tip.classList.add('is-in'); });
    window.brfTipLife(tip, hideTip);
  }
  /* open on the selected colour's photo: decode it first, then jump with no fade, so nothing blank or sliding shows */
  function land(v){
    var m = v && v.featured_media, f = file(v && v.featured_image && v.featured_image.src); if (!m || !m.id) return;
    function ready(img, go){
      if (!img) return go();
      img.loading = 'eager'; var done = 0, fin = function(){ if (!done) { done = 1; go(); } };
      if (img.complete && img.naturalWidth) return fin();
      (img.decode ? img.decode() : Promise.reject()).then(fin, function(){ img.addEventListener('load', fin, {once: true}); });
      setTimeout(fin, 1500);
    }
    var cur = doc.querySelector('.product-gallery__carousel-item.is-selected'), th = doc.querySelector('.product-gallery__thumbnail[data-media-id="' + m.id + '"]');
    if (cur && th && cur.getAttribute('data-media-id') !== String(m.id)) {
      var it = doc.querySelector('.product-gallery__carousel-item[data-media-id="' + m.id + '"]'), g = doc.querySelector('.product-gallery');
      ready(it && it.querySelector('img'), function(){
        if (Date.now() - userAt < 3000) return;   /* the shopper already moved the photos */
        ownAt = Date.now(); g.classList.add('brf-pp-instant'); th.click(); lastMedia = String(m.id);
        requestAnimationFrame(function(){ requestAnimationFrame(function(){ g.classList.remove('brf-pp-instant'); }); });
      });
    }
    [].forEach.call(doc.querySelectorAll('.brf-mg__track'), function(tr){
      var sl = tr.querySelectorAll('.brf-mg__slide'), k = -1;
      for (var i = 0; i < sl.length; i++) { var im = sl[i].querySelector('img'); if (im && file(im.currentSrc || im.src) === f) { k = i; break; } }
      if (k < 1) return;
      ready(sl[k].querySelector('img'), function(){
        if (Date.now() - userAt < 3000 || tr.scrollLeft > 4) return;
        ownAt = Date.now(); lastIdx = k;
        var sb = tr.style.scrollBehavior; tr.style.scrollBehavior = 'auto';
        tr.scrollLeft += sl[k].getBoundingClientRect().left - tr.getBoundingClientRect().left;
        tr.style.scrollBehavior = sb;
      });
    });
  }
  function init(pj){
    var vs = pj && pj.variants; if (!vs || vs.length < 2) return;
    var os = pj.options || []; for (var i = 0; i < os.length; i++) if (/colou?r/i.test(os[i].name || os[i])) { opt = i + 1; break; }
    vs.forEach(function(v){
      var m = v.featured_media; if (m && m.id && !byMedia[m.id]) { byMedia[m.id] = v; n++; }
      var f = file((v.featured_image && v.featured_image.src) || (m && m.preview_image && m.preview_image.src)); if (f && !byFile[f]) byFile[f] = v;
    });
    if (n < 2) return;
    var s = doc.querySelector('.product-gallery__carousel-item.is-selected'); lastMedia = s ? s.getAttribute('data-media-id') : '';
    ['pointerdown', 'touchstart', 'keydown', 'click', 'wheel'].forEach(function(ev){ doc.addEventListener(ev, user, {capture: true, passive: true}); });
    new MutationObserver(function(){ clearTimeout(t); t = setTimeout(desk, 60); }).observe(doc.querySelector('.product-gallery') || doc.body, {subtree: true, attributes: true, attributeFilter: ['class']});
    [].forEach.call(doc.querySelectorAll('.brf-mg__track'), function(tr){
      var sl = tr.querySelectorAll('.brf-mg__slide'), st = 0; lastIdx = 0;
      tr.addEventListener('scroll', function(){ clearTimeout(st); st = setTimeout(function(){ phone(tr); }, 160); }, {passive: true});
    });
    doc.addEventListener('click', function(e){ if (e.target.closest && e.target.closest('.brf-garrow, .brf-mg, .product-gallery__thumbnail')) hideTip(); }, true);
    var idEl = doc.querySelector('form[action*="/cart/add"][id^="product-form-main"] [name="id"]') || doc.querySelector('.product-form [name="id"]');
    var sel = idEl && vs.filter(function(v){ return String(v.id) === idEl.value; })[0];
    land(sel);
    setTimeout(showTip, 1800);
  }
  /* product pages only: the variant photos come from /products/<handle>.js (has featured_media for every variant) */
  function go(){
    if (!doc.body.classList.contains('template-product') || !doc.querySelector('.product-gallery, .brf-mg') || !window.fetch) return;
    var m = /\/products\/([^\/?#]+)/.exec(location.pathname); if (!m) return;
    fetch('/products/' + m[1] + '.js', {credentials: 'same-origin'}).then(function(r){ return r.ok ? r.json() : null; }).then(init).catch(function(){});
  }
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', go); else go();   /* loads in <head>, before <body> exists */
})();

/* ===== from snippets/brf-load-calm.liquid ===== */
/* Bull Ring 2026-10-30 (Abid): products with no colour/size choice and 2+ photos get tiny photo dots at the bottom of the
   main photo (how many photos, which one is showing). Tap a dot to jump to that photo. Going past the last photo
   (next arrow, or a swipe past the end on phones) flies back to the first one, with a little magic: the photos whoosh
   back, the first photo settles in from a soft blur, a sprinkle of sparkles streaks across, and a light runs back along
   the dots. Calm in reduced motion (plain jump) and lighter in smooth mode (html.brf-lite).
   Press on the dots and drag along them (mouse or finger) to scrub through every photo live, like iPhone page dots;
   a plain tap on a dot still jumps to it. A one-off tip (brf-tips id 'pdots') explains the drag. */
(function(){
  if (window.__brfPhotoDots) return; window.__brfPhotoDots = 1;
  var doc = document, still = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var host, pill, dots = [], cur = -1, n = 0, magicAt = 0, scrubbing = false, tip = null;
  function track(){ return [].filter.call(doc.querySelectorAll('.brf-mg__track'), function(t){ return t.offsetWidth > 0; })[0]; }
  function index(){
    var tr = track();
    if (tr) { var sl = tr.querySelectorAll('.brf-mg__slide'), r0 = tr.getBoundingClientRect(), best = 0, bd = 1e9;
      for (var i = 0; i < sl.length; i++) { var d = Math.abs(sl[i].getBoundingClientRect().left - r0.left); if (d < bd) { bd = d; best = i; } } return best; }
    var items = doc.querySelectorAll('.product-gallery__carousel-item');
    return Math.max(0, [].indexOf.call(items, doc.querySelector('.product-gallery__carousel-item.is-selected')));
  }
  /* the magic: dots wave + photo settle (CSS, keyed on .brf-pdots-rw) and a sprinkle of sparkles */
  function magic(){
    if (still || Date.now() - magicAt < 800) return; magicAt = Date.now();
    host.classList.remove('brf-pdots-rw'); pill.classList.remove('is-rewind'); void host.offsetWidth;
    host.classList.add('brf-pdots-rw'); pill.classList.add('is-rewind');
    setTimeout(function(){ host.classList.remove('brf-pdots-rw'); }, 1100);
    var lite = doc.documentElement.classList.contains('brf-lite'), k = lite ? 6 : 14, dust = doc.createElement('div'); dust.className = 'brf-pdust'; dust.setAttribute('aria-hidden', 'true');
    for (var i = 0; i < k; i++) {
      var s = doc.createElement('i'), big = Math.random() < .35;
      s.style.cssText = 'top:' + (12 + Math.random() * 70).toFixed(1) + '%;left:' + (-8 + Math.random() * 30).toFixed(1) + '%;--d:' + (Math.random() * .22).toFixed(2) + 's;--x:' + (55 + Math.random() * 45).toFixed(0) + 'vw;--s:' + (big ? 1 : .55 + Math.random() * .3).toFixed(2);
      if (Math.random() < .45) s.className = 'is-gold';
      dust.appendChild(s);
    }
    host.appendChild(dust); setTimeout(function(){ if (dust.parentNode) dust.parentNode.removeChild(dust); }, 1300);
    try { if (!sessionStorage.getItem('brf-pdots-lot')) { sessionStorage.setItem('brf-pdots-lot', '1'); var note = doc.createElement('div'); note.className = 'brf-pdots__note'; note.textContent = '✨ That’s the lot, back to the start'; host.appendChild(note); setTimeout(function(){ if (note.parentNode) note.parentNode.removeChild(note); }, 2400); } } catch (e) {}
  }
  function sync(){
    var i = index(); if (i === cur) return;
    if (cur === n - 1 && i < cur - 1 && !scrubbing) magic();   /* a jump back from the last photo (arrow wrap, or the phone gallery heading home) */
    cur = i; dots.forEach(function(d, k){ d.classList.toggle('is-on', k === i); d.setAttribute('aria-current', k === i ? 'true' : 'false'); });
  }
  /* phones: a quick whoosh home with an ease-out settle (snap is paused so it can't fight the glide) */
  function home(tr){
    if (still) { tr.scrollLeft = 0; return; }
    var from = tr.scrollLeft, t0 = 0, dur = 520, snap = tr.style.scrollSnapType, sb = tr.style.scrollBehavior;
    tr.style.scrollSnapType = 'none'; tr.style.scrollBehavior = 'auto';
    (function step(t){ if (!t0) t0 = t; var p = Math.min(1, (t - t0) / dur), e = 1 - Math.pow(1 - p, 4); tr.scrollLeft = from * (1 - e);
      if (p < 1) requestAnimationFrame(step); else { tr.style.scrollSnapType = snap; tr.style.scrollBehavior = sb; } })(performance.now());
  }
  function go(i){
    var tr = track();
    if (tr) { var s = tr.querySelectorAll('.brf-mg__slide')[i]; if (s) tr.scrollTo({left: tr.scrollLeft + s.getBoundingClientRect().left - tr.getBoundingClientRect().left, behavior: still ? 'auto' : 'smooth'}); return; }
    var th = doc.querySelectorAll('.product-gallery__thumbnail')[i]; if (th) th.click();
  }
  /* jump straight to photo i (no smooth scroll, no fade) - used while scrubbing */
  function jump(i){
    var tr = track();
    if (tr) { var s = tr.querySelectorAll('.brf-mg__slide')[i]; if (s) tr.scrollLeft += s.getBoundingClientRect().left - tr.getBoundingClientRect().left; return; }
    var th = doc.querySelectorAll('.product-gallery__thumbnail')[i], g = doc.querySelector('.product-gallery');
    if (th) { if (g) g.classList.add('brf-pp-instant'); th.click(); }
  }
  function hideTip(){ if (!tip) return; var x = tip; tip = null; x.classList.remove('is-in'); setTimeout(function(){ if (x.parentNode) x.parentNode.removeChild(x); }, 300); }
  function scrub(){
    var down = false, moved = false, x0 = 0, last = -1, snap = '', tr = null;
    function at(x){ var r = pill.getBoundingClientRect(), p = Math.max(0, Math.min(.9999, (x - r.left - 9) / Math.max(1, r.width - 18))); return Math.floor(p * n); }
    pill.addEventListener('pointerdown', function(e){
      if (e.button) return; down = true; moved = false; x0 = e.clientX; last = index();
    });
    pill.addEventListener('pointermove', function(e){
      if (!down) return;
      if (!moved && Math.abs(e.clientX - x0) < 6) return;
      if (!moved) { moved = true; scrubbing = true; try { pill.setPointerCapture(e.pointerId); } catch (x) {} pill.classList.add('is-scrub'); hideTip(); tr = track(); if (tr) { snap = tr.style.scrollSnapType; tr.style.scrollSnapType = 'none'; tr.style.scrollBehavior = 'auto'; } }
      var i = at(e.clientX); if (i === last) return; last = i; jump(i);
      dots[i].classList.remove('is-tick'); void dots[i].offsetWidth; dots[i].classList.add('is-tick');
      cur = i; dots.forEach(function(d, k){ d.classList.toggle('is-on', k === i); });
    });
    function end(){
      if (!down) return; down = false;
      if (moved) {
        pill.classList.remove('is-scrub'); var g = doc.querySelector('.product-gallery'); if (g) g.classList.remove('brf-pp-instant');
        if (tr) { tr.style.scrollSnapType = snap; tr.style.scrollBehavior = ''; }
        setTimeout(function(){ scrubbing = false; cur = index(); }, 250);
        pill.__brfSwallow = Date.now();
      }
    }
    pill.addEventListener('pointerup', end); pill.addEventListener('pointercancel', end);
    pill.addEventListener('lostpointercapture', function(e){ if (e.target === pill) end(); });   /* a dot handing its touch capture over to the pill is not the end */
    pill.addEventListener('click', function(e){ if (Date.now() - (pill.__brfSwallow || 0) < 350) { e.preventDefault(); e.stopPropagation(); } }, true);
  }
  function showTip(){
    var seen = {}; try { seen = JSON.parse(localStorage.getItem('brf-tips') || '{}') || {}; } catch (e) { return; }
    if (seen.pdots || window.__brfTipShown || still) return;
    var r = host.getBoundingClientRect(); if (r.bottom < 80 || r.top > innerHeight - 80) return;
    window.__brfTipShown = 1; seen.pdots = 1; try { localStorage.setItem('brf-tips', JSON.stringify(seen)); } catch (e) {}
    tip = doc.createElement('div'); tip.className = 'brf-pdots__tip'; tip.setAttribute('role', 'status');
    tip.textContent = matchMedia('(hover: none)').matches ? 'Psst… slide your finger along the dots to flick through every photo ✨' : 'Psst… drag along the dots to whizz through every photo ✨';
    host.appendChild(tip); requestAnimationFrame(function(){ if (tip) tip.classList.add('is-in'); });
    var x = tip; if (window.brfTipLife) window.brfTipLife(x, function(){ if (tip === x) hideTip(); }); else setTimeout(function(){ if (tip === x) hideTip(); }, 8000);
  }
  function build(){
    host = doc.querySelector('.product-gallery__carousel-wrapper'); if (!host) return;
    n = Math.max(doc.querySelectorAll('.product-gallery__carousel-item').length, (track() || {children: []}).children.length);
    if (n < 2 || n > 24) return;
    pill = doc.createElement('div'); pill.className = 'brf-pdots'; pill.setAttribute('role', 'group'); pill.setAttribute('aria-label', 'Photos');
    for (var i = 0; i < n; i++) (function(k){
      var b = doc.createElement('button'); b.type = 'button'; b.className = 'brf-pdots__d'; b.setAttribute('aria-label', 'Photo ' + (k + 1) + ' of ' + n);
      b.addEventListener('click', function(e){ e.preventDefault(); e.stopPropagation(); go(k); });
      pill.appendChild(b); dots.push(b);
    })(i);
    pill.title = 'Drag along the dots to flick through the photos';
    host.appendChild(pill); sync(); scrub();
    setTimeout(showTip, 2000);
    var t = 0, later = function(){ clearTimeout(t); t = setTimeout(sync, 40); };
    new MutationObserver(later).observe(host, {subtree: true, attributes: true, attributeFilter: ['class']});
    [].forEach.call(doc.querySelectorAll('.brf-mg__track'), function(tr){
      tr.addEventListener('scroll', later, {passive: true});
      /* phones: a swipe past the last photo flies back to the first */
      var x0 = 0, end = false;
      tr.addEventListener('touchstart', function(e){ x0 = e.touches[0].clientX; end = tr.scrollLeft >= tr.scrollWidth - tr.clientWidth - 2; }, {passive: true});
      tr.addEventListener('touchend', function(e){
        var dx = (e.changedTouches[0] || {}).clientX - x0;
        if (end && dx < -40) { cur = n - 1; magic(); home(tr); }
      }, {passive: true});
    });
  }
  function init(){
    if (!doc.body.classList.contains('template-product') || !window.fetch) return;
    var m = /\/products\/([^\/?#]+)/.exec(location.pathname); if (!m) return;
    fetch('/products/' + m[1] + '.js', {credentials: 'same-origin'}).then(function(r){ return r.ok ? r.json() : null; })
      .then(function(p){ if (p && p.variants && p.variants.length === 1 && (p.media || p.images || []).length > 1) build(); }).catch(function(){});
  }
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', init); else init();   /* loads in <head>, before <body> exists */
})();

/* ===== from snippets/brf-load-calm.liquid ===== */
/* Bull Ring 2026-10-30 (Abid): on product cards, picking an option with its own price (e.g. "Pack Of 3 – £27.99")
   shows that option's price on the card instead of "From £15.99"; sale options show the old price too.
   Prices come from /products/<handle>.js (one cached look-up per product, only when a card's options differ in price). */
(function(){
  if (window.__brfCardPrice) return; window.__brfCardPrice = 1;
  var doc = document, cache = {};
  function money(c){ var s = (c / 100).toFixed(2); return '£' + (/\.00$/.test(s) ? s.slice(0, -3) : s).replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
  function handle(card){ var a = card.querySelector('a[href*="/products/"]'), m = a && /\/products\/([^\/?#]+)/.exec(a.getAttribute('href')); return m ? m[1] : ''; }
  function apply(sel){
    var card = sel.closest('.product-item, .brf-ucard'), o = sel.options[sel.selectedIndex]; if (!card || !o || !o.value || o.hasAttribute('data-brf-out')) return;
    var h = handle(card); if (!h) return;
    (cache[h] = cache[h] || fetch('/products/' + h + '.js', {credentials: 'same-origin'}).then(function(r){ return r.ok ? r.json() : null; }))
      .then(function(p){
        if (!p || !p.variants) return;
        var v = p.variants.filter(function(x){ return String(x.id) === o.value; })[0]; if (!v) return;
        var same = p.variants.every(function(x){ return x.price === v.price && (x.compare_at_price || 0) === (v.compare_at_price || 0); });
        if (same) return;   /* every option costs the same: the card already shows the right price */
        var sale = v.compare_at_price && v.compare_at_price > v.price;
        var pl = card.querySelector('.product-item__price-list');
        if (pl) {
          var unit = pl.querySelector('.brf-unit');
          pl.innerHTML = sale ? '<span class="price price--highlight">' + money(v.price) + '</span><span class="price price--compare">' + money(v.compare_at_price) + '</span>'
                              : '<span class="price">' + money(v.price) + '</span>';
          if (unit) pl.appendChild(unit);
          pl.removeAttribute('data-brf-pm'); pl.classList.remove('brf-pm-2');   /* let the sale-row tidy-up look at it again */
        }
        var up = card.querySelector('.brf-ucard__price');
        if (up) up.innerHTML = sale ? '<strong class="is-sale">' + money(v.price) + '</strong> <s>' + money(v.compare_at_price) + '</s>' : '<strong>' + money(v.price) + '</strong>';
      }).catch(function(){ delete cache[h]; });
  }
  doc.addEventListener('change', function(e){ var t = e.target; if (t && t.matches && t.matches('select[data-brf-pick], .brf-ucard__select')) apply(t); });
  /* a colour dot sets the picker without a change event: catch it when the picker's value moves */
  doc.addEventListener('change', function(e){
    var t = e.target; if (!t || !t.matches || !t.matches('.product-item .color-swatch__radio')) return;
    var sel = t.closest('.product-item').querySelector('select[data-brf-pick]'); if (sel) setTimeout(function(){ apply(sel); }, 0);
  });
})();

/* ===== from snippets/brf-load-calm.liquid ===== */
/* Bull Ring 2026-10-30 (Abid): the bag drawer's "More below" pill (brf-x-v2-fixes.js) showed whenever the drawer list could
   scroll at all, so with one item it sat over the "Finish your project" row. Keep it only when bag items are actually
   hidden below ("2 more items"); the plain "More below" (just the extras under the items) is hidden. */
(function(){
  if (window.__brfMoreFix) return; window.__brfMoreFix = 1;
  var doc = document;
  function check(p){ var s = p.querySelector('span'), off = !s || !/\d/.test(s.textContent); if (p.classList.contains('brf-mb-off') !== off) p.classList.toggle('brf-mb-off', off); }
  function scan(){ [].forEach.call(doc.querySelectorAll('.brf-mc__more'), check); }
  function go(){ scan(); new MutationObserver(scan).observe(doc.body, {subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['hidden']}); }
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', go); else go();   /* loads in <head>, before <body> exists */
})();

/* ===== from snippets/brf-load-calm.liquid ===== */
/* Bull Ring 2026-10-30 (Abid): the quick view opens on the pre-picked colour's own photo (like the product page), not the
   all-colours photo. The quick view is loaded by AJAX, so this watches for it opening; the photo is decoded first and the
   gallery jumps there with no fade. Changing colour inside the quick view already moves the photo (theme). */
(function(){
  if (window.__brfQvLand) return; window.__brfQvLand = 1;
  var doc = document, cache = {}, t = 0;
  function land(m){
    if (m.__brfLanded) return;
    var idEl = m.querySelector('form[action*="/cart/add"] [name="id"]'), pjEl = m.querySelector('[data-product-json]'), g = m.querySelector('.product-gallery');
    if (!idEl || !pjEl || !g || !m.querySelector('.product-gallery__carousel-item.is-selected')) return;
    var h; try { h = JSON.parse(pjEl.textContent).product.handle; } catch (e) { return; }
    m.__brfLanded = 1;
    (cache[h] = cache[h] || fetch('/products/' + h + '.js', {credentials: 'same-origin'}).then(function(r){ return r.ok ? r.json() : null; })).then(function(p){
      if (!p || !p.variants || p.variants.length < 2) return;
      var v = p.variants.filter(function(x){ return String(x.id) === idEl.value; })[0], md = v && v.featured_media; if (!md || !md.id) return;
      var cur = m.querySelector('.product-gallery__carousel-item.is-selected'), th = m.querySelector('.product-gallery__thumbnail[data-media-id="' + md.id + '"]');
      if (!cur || !th || cur.getAttribute('data-media-id') === String(md.id)) return;
      var it = m.querySelector('.product-gallery__carousel-item[data-media-id="' + md.id + '"]'), img = it && it.querySelector('img'), done = 0;
      function go(){ if (done) return; done = 1; if (m.getAttribute('aria-hidden') === 'true') return;
        g.classList.add('brf-pp-instant'); th.click(); requestAnimationFrame(function(){ requestAnimationFrame(function(){ g.classList.remove('brf-pp-instant'); }); }); }
      if (!img || (img.complete && img.naturalWidth)) return go();
      img.loading = 'eager';
      (img.decode ? img.decode() : Promise.reject()).then(go, function(){ img.addEventListener('load', go, {once: true}); });
      setTimeout(go, 1500);
    }).catch(function(){ delete cache[h]; m.__brfLanded = 0; });
  }
  function scan(){ [].forEach.call(doc.querySelectorAll('.modal[id^="modal-quick-view"]'), function(m){ if (m.getAttribute('aria-hidden') === 'false') land(m); else m.__brfLanded = 0; }); }
  function go(){ new MutationObserver(function(){ clearTimeout(t); t = setTimeout(scan, 80); }).observe(doc.body, {subtree: true, childList: true, attributes: true, attributeFilter: ['aria-hidden']}); }
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', go); else go();   /* loads in <head>, before <body> exists */
})();

/* ===== from snippets/brf-load-calm.liquid ===== */
/* Bull Ring 2026-10-30 (Abid): hovering a colour swatch shows its name in a small bubble straight away (the browser's own
   title tooltip waits about a second). Quick view swatches, product page swatches, card colour dots and the Choose design
   sheet. Mouse only; phones are unchanged. A sold-out colour gets a quiet second line. */
(function(){
  if (window.__brfCName) return; window.__brfCName = 1;
  if (!matchMedia('(hover: hover) and (pointer: fine)').matches) return;
  var doc = document, SEL = '.brf-qvsw__b, .variant-swatch, .color-swatch, .block-swatch:has(.brf-cdot), .brf-vp__mini, .brf-vps__card .brf-vps__img';
  var tip = null, cur = null;
  function nameOf(el){
    var src = el.matches('.variant-swatch, .color-swatch, .block-swatch') ? (el.querySelector('label') || el.querySelector('input') || el) : el;
    var inp = el.querySelector && el.querySelector('input');
    var n = el.getAttribute('data-brf-name') || src.getAttribute('data-brf-name') || src.getAttribute('title') || el.getAttribute('title') || src.getAttribute('aria-label') || el.getAttribute('data-v') && el.getAttribute('title') || (inp && (inp.getAttribute('data-value') || inp.value)) || '';
    if (el.matches('.brf-vps__img')) { var c = el.closest('.brf-vps__card'); n = (c.querySelector('.brf-vps__name') || {}).textContent || ''; }
    n = String(n).replace(/\s+/g, ' ').trim();
    var out = /\s*[·\-–]\s*sold out$/i.test(n) || el.matches('.variant-swatch--disabled, .color-swatch--disabled, .brf-dot-out, .is-out') || (el.closest('.color-swatch') || {classList: {contains: function(){}}}).classList.contains('brf-dot-out') || (el.closest('.brf-vps__card.is-out') ? true : false);
    return {n: n.replace(/\s*[·\-–]\s*sold out$/i, ''), out: !!out};
  }
  function hush(el){ [el, el.querySelector('label'), el.querySelector('[title]')].forEach(function(x){ if (x && x.hasAttribute && x.hasAttribute('title')) { x.setAttribute('data-brf-name', x.getAttribute('title')); x.removeAttribute('title'); } }); }
  function show(el){
    hush(el);
    var d = nameOf(el); if (!d.n) return;
    if (!tip) { tip = doc.createElement('div'); tip.className = 'brf-cname'; tip.setAttribute('aria-hidden', 'true'); doc.body.appendChild(tip); }
    tip.innerHTML = ''; var b = doc.createElement('b'); b.textContent = d.n; tip.appendChild(b);
    if (d.out) { var s = doc.createElement('small'); s.textContent = 'Sold out'; tip.appendChild(s); }
    var r = el.getBoundingClientRect(), w = tip.offsetWidth, h = tip.offsetHeight;
    var x = Math.max(8, Math.min(innerWidth - w - 8, r.left + r.width / 2 - w / 2)), y = r.top - h - 9, below = y < 8;
    if (below) y = r.bottom + 9;
    tip.style.left = x + 'px'; tip.style.top = y + 'px'; tip.classList.toggle('is-below', below);
    tip.style.setProperty('--ax', Math.max(10, Math.min(w - 10, r.left + r.width / 2 - x)) + 'px');
    tip.classList.remove('is-in'); void tip.offsetWidth; tip.classList.add('is-in');
  }
  function hide(){ cur = null; if (tip) tip.classList.remove('is-in'); }
  doc.addEventListener('pointerover', function(e){
    if (e.pointerType && e.pointerType !== 'mouse') return;
    var el = e.target.closest && e.target.closest(SEL);
    if (el === cur) return; if (!el) { if (cur) hide(); return; }
    cur = el; show(el);
  }, true);
  doc.addEventListener('pointerout', function(e){ if (cur && !(e.relatedTarget && cur.contains(e.relatedTarget))) hide(); }, true);
  /* it only ever shows under the mouse, so a drawer or sheet on top simply means no hover target; any click or scroll clears it */
  addEventListener('scroll', hide, true); addEventListener('blur', hide); doc.addEventListener('pointerdown', hide, true);
})();

/* ===== from snippets/brf-load-calm.liquid ===== */
/* Bull Ring 2026-10-30 (Abid): the hCaptcha badge (Shopify forms, bottom-right) was hidden behind our "Chat with us"
   launcher, and on phones behind the sticky Add to bag bar. The badge must stay visible, so it is lifted to sit 12px above
   whatever is in the bottom-right corner (chat launcher or Add to bag bar) and drops back when that moves away. */
(function(){
  if (window.__brfHcap) return; window.__brfHcap = 1;
  var doc = document, html, badge = null, raf = 0, last = -1;
  function chatTop(){
    var chat = doc.querySelector('shopify-chat'); if (!chat) return innerHeight;
    var top = innerHeight, pe = badge.style.pointerEvents; badge.style.pointerEvents = 'none'; badge.style.visibility = 'hidden';
    for (var y = innerHeight - 2; y > innerHeight - 280; y -= 6) { var e = doc.elementFromPoint(innerWidth - 28, y); if (e === chat) top = y; }
    badge.style.pointerEvents = pe; badge.style.visibility = '';
    return top;
  }
  function barTop(){
    var s = doc.querySelector('.brf-sticky-atc'); if (!s || getComputedStyle(s).visibility !== 'visible') return innerHeight;
    var r = s.getBoundingClientRect(); return r.right > innerWidth - 60 && r.top < innerHeight ? r.top : innerHeight;
  }
  function place(){
    raf = 0; if (!badge || !badge.isConnected) return;
    var top = Math.min(chatTop(), barTop()), b = top < innerHeight ? Math.round(innerHeight - top + 12) : 20;
    if (b === last) return; last = b;
    html.classList.add('brf-hcap'); html.style.setProperty('--brf-hcap-b', b + 'px');
  }
  function later(){ if (!raf) raf = requestAnimationFrame(function(){ setTimeout(place, 60); }); }
  function find(){
    if (badge && badge.isConnected) return;
    badge = doc.getElementById('shop-hcaptcha-badge-container'); if (!badge) return;
    place(); setTimeout(place, 800); setTimeout(place, 2500);   /* the chat launcher can arrive later */
  }
  function go(){
    html = doc.documentElement; find();
    new MutationObserver(function(){ if (!badge || !badge.isConnected) find(); }).observe(doc.body, {childList: true});
    addEventListener('scroll', function(){ if (badge) later(); }, {passive: true});
    addEventListener('resize', function(){ if (badge) later(); });
    new MutationObserver(function(){ if (badge) later(); }).observe(html, {attributes: true, attributeFilter: ['class']});
  }
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', go); else go();   /* loads in <head>, before <body> exists */
})();
